/* SFIORA — comportements minimaux. Aucune dépendance. */
document.addEventListener('DOMContentLoaded', function () {

  /* Header : le wordmark disparaît au scroll (il ne rétrécit pas) */
  var hd = document.querySelector('.site-header');
  if (hd && hd.dataset.collapse === 'true') {
    window.addEventListener('scroll', function () {
      hd.classList.toggle('min', window.scrollY > 110);
    }, { passive: true });
  }

  /* Menu mobile */
  var burger = document.querySelector('.burger');
  if (burger) burger.addEventListener('click', function () {
    document.querySelector('.nav-main').classList.toggle('open');
  });

  /* Accordéons FAQ — plusieurs ouverts autorisés */
  document.querySelectorAll('.q').forEach(function (q) {
    q.addEventListener('click', function () { q.classList.toggle('open'); });
  });

  /* Accordéons fiche produit — un seul ouvert à la fois */
  document.querySelectorAll('.ac').forEach(function (a) {
    a.querySelector('.ach').addEventListener('click', function () {
      var was = a.classList.contains('open');
      a.closest('.acc').querySelectorAll('.ac').forEach(function (x) { x.classList.remove('open'); });
      if (!was) a.classList.add('open');
    });
  });

  /* Afficher / masquer le mot de passe */
  document.querySelectorAll('.eye').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var i = b.parentNode.querySelector('input');
      var show = i.type === 'password';
      i.type = show ? 'text' : 'password';
      b.textContent = show ? 'MASQUER' : 'AFFICHER';
    });
  });

  /* Onglets Connexion / Créer un compte */
  document.querySelectorAll('.tab').forEach(function (t) {
    t.addEventListener('click', function () {
      var box = t.closest('.acct') || document;
      box.querySelectorAll('.tab').forEach(function (x) { x.classList.remove('on'); });
      box.querySelectorAll('.pane').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      var p = box.querySelector('#' + t.dataset.tab);
      if (p) p.classList.add('on');
    });
  });

  /* Sélecteur de coloris : bascule visuelle + soumission de la variante */
  document.querySelectorAll('.swatches').forEach(function (grp) {
    grp.addEventListener('change', function (e) {
      grp.querySelectorAll('.sw').forEach(function (s) { s.classList.remove('on'); });
      var lab = e.target.closest('.sw');
      if (lab) lab.classList.add('on');
      var out = document.querySelector('[data-swatch-name]');
      if (out && lab) out.textContent = lab.dataset.value;
      var f = grp.closest('form');
      if (f && f.dataset.autosubmit === 'true') f.submit();
    });
  });

  /* Carrousel « à accumuler avec » */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('.rtrack');
    var prev = c.querySelector('[data-prev]');
    var next = c.querySelector('[data-next]');
    if (!track || !track.children.length) return;
    var total = track.children.length;
    var i = 0;
    function per() { return window.innerWidth <= 1100 ? 2 : 4; }
    function upd() {
      var step = track.children[0].getBoundingClientRect().width + 26;
      track.style.transform = 'translateX(-' + (i * step) + 'px)';
      prev.disabled = i === 0;
      next.disabled = i >= total - per();
    }
    prev.addEventListener('click', function () { if (i > 0) { i--; upd(); } });
    next.addEventListener('click', function () { if (i < total - per()) { i++; upd(); } });
    window.addEventListener('resize', function () { i = 0; upd(); });
    upd();
  });

});
